// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@umijs/deps/compiled/css-loader/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "", ""]);
// Exports
module.exports = exports;
